import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { BasePersonselectionComponent } from './base-personselection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-personselection',
    imports: [
    NgClass,
    NgTemplateOutlet,
    TranslatePipe
],
    templateUrl: './personselection.component.html',
    styleUrl: './personselection.component.scss'
})
export class PersonselectionComponent extends BasePersonselectionComponent {

    constructor(){
    super()
  }

}
